import StiAttributes from './StiAttributes';

export default StiAttributes;
